import * as React from "react";
import { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import axios from "axios";
import { BASE_URL } from "../Components/Api/Api";
import SweetAlert from "../Components/SweetAlert/SweetAlert";

let rowcount = 1;
export const ThirdStep = ({  insuranceId }) => {
  console.log(insuranceId);
  const [choicesInheritance, setChoicesInheritance] = useState("");
  const [tableData, setTableData] = useState([
    { insid: insuranceId, name: "", relation: "", idcode: "", bd: "" },
  ]);

  const handleInputChange = (e, id, index, column) => {
    const newTableData = [...tableData];
    newTableData[index] = {
      ...newTableData[index],
      [column]: e.target.value,
    };

    console.log("awd");
    setTableData(newTableData);
  };
  const handleAddRow = () => {
    const newRow = {
      insid: insuranceId,
      id: rowcount,
      name: ``,
      relation: "",
      idcode: "",
      bd: "",
    };
    rowcount += 1;

    setTableData((prevData) => [...prevData, newRow]);
  };

  const sendLowInsurance = async () => {
    const bodyFormData = new FormData();
    bodyFormData.append("step", 3);
    bodyFormData.append("zinaf", 0);
    bodyFormData.append("id", insuranceId);
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: "createinsurance",
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        if (responseGlobal?.data?.UserId === "0") {
          // dispatch(logoutStatic());
          // navigate('/')
        }
        SweetAlert({
          title: "",
          text: "کاربر جدید اضافه شد.",
          type: "success",
        });
        // fetchdata()
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };

  const handleSaveLowInheritance = () => {
    console.log("Table Data:", tableData);
    sendLowInsurance();
  };

  const handleSave = async () => {
    console.log(tableData);
    const bodyFormData = new FormData();
    bodyFormData.append("step", 3);
    bodyFormData.append("zinaf", 1);
    bodyFormData.append("id", insuranceId);
    bodyFormData.append("zf", JSON.stringify(tableData));
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: "createinsurance",
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        if (responseGlobal?.data?.UserId === "0") {
          // dispatch(logoutStatic());
          // navigate('/')
        }
        SweetAlert({
          title: "",
          text: "کاربر جدید اضافه شد.",
          type: "success",
        });
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };
  return (
    <div dir="rtl" className="m-5">
      <Row>
        <Col className=" col-12 col-lg-6 ">
          <Form.Group
            className="mb-3 d-flex flex-column  drop-down-group "
            controlId="formBasicEdu"
          >
            <Form.Label className="fw-bold pb-1">وراث </Form.Label>
            <Form.Select
              defaultValue={""}
              aria-label="Default select example"
              onChange={(e) => {
                setChoicesInheritance(e.target.value);
                // if (e.target.value === "2") {
                // } else {
                //   setChoicesInheritance(false);
                // }
              }}
            >
              <option value="" disabled>
                انتخاب کنید...
              </option>
              <option value="1">وراث قانونی</option>
              <option value="2">وراث انتخابی</option>
            </Form.Select>
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col className={"col-12 col-lg-6"}>
          {choicesInheritance === "1" && (
            <div className="d-flex gap-1">
            <button
              className={`btn btn-success`}
              onClick={handleSaveLowInheritance}
              >
              ذخیره
            </button>
                </div>
          )}
        </Col>
        </Row>
      {choicesInheritance === "2" && (
        <div>
          <h3>اطلاعات ذی نفعان </h3>
          <p>وراث خود را تعیین کنید.</p>
          <div  class="table-responsive">
            <table className="table">
              <thead>
                <tr>
                  <th>نام و نام خانوادگی</th>
                  <th>نسبت ذی نفع</th>
                  <th>کدملی ذی نفع</th>
                  <th>تاریخ تولد</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr key={row.id}>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={row.column1}
                        onChange={(e) =>
                          handleInputChange(e, row.id, index, "name")
                        }
                      />
                    </td>
                    <td>
                      <select
                        defaultValue={""}
                        className="form-select"
                        value={row.column2}
                        onChange={(e) =>
                          handleInputChange(e, row.id, index, "relation")
                        }
                      >
                        <option value="" disabled>
                          انتخاب کنید...
                        </option>
                        <option value="فرزند">فرزند</option>
                        <option value="همسر">همسر</option>
                        <option value="پدر">پدر</option>
                        <option value="مادر">مادر</option>
                        <option value="خواهر">خواهر</option>
                        <option value="برادر">برادر</option>
                      </select>
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={row.column3}
                        onChange={(e) =>
                          handleInputChange(e, row.id, index, "idcode")
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={row.column4}
                        onChange={(e) =>
                          handleInputChange(e, row.id, index, "bd")
                        }
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
            <div>
              <button className="btn btn-primary pl-1" onClick={handleAddRow}>
                +افزودن سطر جدید
              </button>
            </div>
            <div className="d-flex justify-content-end gap-1">
              <button className="btn btn-success" onClick={handleSave}>
                ذخیره
              </button>
            </div>
        </div>
      )}
    </div>
  );
};
